// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fdrj","questions":"styles_questions__2RTZh","footer":"styles_footer__sF9qL"};